import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../../@core/services';

@Injectable({
  providedIn: 'root'
})
export class ModuleTrackingService {

  private END_POINT = '';

  private currentLogId: any = null;
  private isTrackingStarted = false;

  constructor(private config: ConfigService, protected http: HttpClient) {}

  // 🔹 CREATE MODULE LOG (Entry Time)
  createModuleLog(body: any): Observable<any> {
    this.END_POINT = `${this.config.get().BASE_URL}/v1/ModuleSessionLog/create-module-log`;

    return this.http.post(this.END_POINT, body);
  }

  // 🔹 UPDATE OUT TIME
  updateOutTime(body: any): Observable<any> {
    this.END_POINT = `${this.config.get().BASE_URL}/v1/ModuleSessionLog/update-out-time`;

    return this.http.put(this.END_POINT, body);
  }

  private getUserId(): string {

  const data = localStorage.getItem('refreshToken');

  if (!data) return '';

  try {
    const parsed = JSON.parse(data);
    return parsed.userId || null;
  } catch (e) {
    console.error('Invalid refreshToken format');
    return '';
  }
}

  // 🔥 START TRACKING
  startTracking(moduleId: number, moduleName: string, subModuleId: number, subModuleName: string): Promise<void> {

  return new Promise((resolve) => {

    const userId = this.getUserId();

    const body = {
      userId: userId,
      customerId: null,
      moduleId: moduleId,
      moduleName: moduleName,
      subModuleId: subModuleId || null,
      subModuleName: subModuleName || null,
      entryTimeDate: new Date().toISOString(),
      outTimeDate: null
    };

    this.createModuleLog(body).subscribe((res: any) => {

      if (res.message == "create module log successfully") {
        this.currentLogId = res.id;
        this.isTrackingStarted = true;

      }

      resolve(); // ✅ important
    });

  });
}

  // 🔥 STOP TRACKING
stopTracking() {


  // 🚫 prevent invalid calls
  if (!this.currentLogId || !this.isTrackingStarted) {
     console.log("⚠️ STOP BLOCKED - No valid session");
    return;
  }

  const body = {
    id: this.currentLogId,
    outTimeDate: new Date().toISOString()
  };


  this.updateOutTime(body).subscribe({
    next: () => {},
    error: (err) => console.error('Update failed', err)
  });

  this.currentLogId = null;
  this.isTrackingStarted = false;
}
}